import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

// Init and setup all the events for the component
const initSearchBar = () => {
    // Define base elements and early return check
    const $searchTrigger = $('.js-search-bar-trigger');
    const $searchBar = $('.search-bar');
    const $searchOverlay = $searchBar.find('.search-overlay');
    if (!$searchTrigger.length || !$searchBar.length) { return; }

    // Setup the trigger to open and auto focus the search bar
    $searchTrigger.click(e => {
        e.preventDefault();
        $searchBar.addClass('open');
        $searchOverlay.addClass('is-visible');

        // Delay the focus by 1 seconds so the IE users will catch a glimpse of the
        // placeholder text before it is focus upon
        setTimeout(() => {
            $searchBar.find('input[type="text"]').focus();
        }, 1000);
    });
    attachEnterAsClick($searchTrigger);

    // Setup the trigger to close off the search bar
    // ASSUMPTION: the search bar will ALWAYS come with a close trigger
    const $closeSearchTrigger = $searchBar.find('.js-search-bar-close');
    $closeSearchTrigger.click(() => {
        $searchBar.removeClass('open');
        $searchOverlay.removeClass('is-visible');
    });
    attachEnterAsClick($closeSearchTrigger);

    // Setup the enter press and search button click to trigger the search function
    // ASSUMPTION: the search bar will ALWAYS come with a search input and search button
    const $searchInput = $searchBar.find('input[type="text"]');
    const $searchButton = $searchBar.find('.js-search-bar-search');
    $searchInput.keypress(e => {
        if ((e.keyCode ? e.keyCode : e.which) === 13) { // Enter key
            e.preventDefault();

            if ($('.azure-search-form').length > 0) {
                $closeSearchTrigger.click();
            } else {
                window.location = $searchBar.data('search-url') + encodeURI($(e.target).val());
            }
        }
    });

    // Close the search on ESC key
    $searchInput.keydown(e => {
        if ((e.keyCode ? e.keyCode : e.which) === 27) { // Escape key
            $closeSearchTrigger.click();
        }
    });

    $searchButton.click(e => {
        e.preventDefault();

        if ($('.azure-search-form').length > 0) {
            $closeSearchTrigger.click();
        } else {
            window.location = $searchBar.data('search-url') + encodeURI($searchInput.val());
        }
    });
    attachEnterAsClick($searchButton);

    // Accessibility feature, if the user tab off the search bar, hide / close the search bar
    const closeSearchBarIfNotFocused = () => {
        setTimeout(() => {
            if (!$closeSearchTrigger.is(':focus') && !$searchInput.is(':focus') && !$searchButton.is(':focus')) {
                $closeSearchTrigger.click();
            }
        }, 500);
    };

    $closeSearchTrigger.blur(closeSearchBarIfNotFocused);
    $searchButton.blur(closeSearchBarIfNotFocused);
    $searchInput.blur(closeSearchBarIfNotFocused);
};

// update state
function azureUpdateFormState(el) {
    // mark current form
    window.azure_form = el.closest('.azure-search-form');
    $('.azure-search-form .search-input').val(window.azure_form.find('.search-input').val());
}

// handle redirect
function azureRedirectPage() {
    const { pathname } = window.location;

    let redirect = window.azure_form.data('redirect');

    // ignore redirection if in search page
    if (pathname === redirect) {
        return false;
    }

    // redirect if not in search page and redirect url exist
    if (redirect !== undefined) {
        redirect += `?ask=${window.azure_form.find('.search-input').val()}#s-azure-search-result`;
        window.location = redirect;
        return true;
    }

    return false;
}

// loop item list
function azureAjaxRender(data) {
    const $resultDiv = $('#azure-search-result');
    const $tpl = $('#azure-search-tpl .search-result-item');

    let item;

    // reset result div
    $resultDiv.html('');

    // no result
    if (data.value.length === 0) {
        item = $tpl.clone();

        item.find('.title').remove();

        item.appendTo($resultDiv);
        return;
    }

    // loop item
    data.value.forEach(i => {
        item = $tpl.clone();
        item.find('.no-link-title').remove();
        item.find('.title a').html(i.Name);
        item.find('.title a').attr('href', i.UrlSlug);
        item.find('p').html(i.Summary);

        item.appendTo($resultDiv);
    });
}

// toggle loader
function azureToggleLoader(show) {
    if (show) {
        $('.loading').removeClass('hide');
    } else {
        $('.loading').addClass('hide');
    }
}

// show or hide simple navigation, add event on click
function azureShowHidePagination(start, total, callback) {
    const perpage = window.azure_form.data('perpage') * 1;

    // hide pagination
    $('.c-pagination-minimal li a').addClass('hide');

    // show prev nav
    if (start > 0) {
        $('.c-pagination-minimal .previous a').removeClass('hide');
    }

    // show next prev
    if (start + perpage < total) {
        $('.c-pagination-minimal .next a').removeClass('hide');
    }

    // make sure to remove the event
    $('.s-azure-search-result').off();

    // assign one click
    $('.s-azure-search-result').one('click', '.c-pagination-minimal a', e => {
        e.preventDefault();

        if ($(e.target).parent().hasClass('next')) {
            callback(start + perpage);
        } else {
            callback(start - perpage);
        }
    });
}

// ajax request proccess
function azureAjaxRequest(start) {
    const perpage = window.azure_form.data('perpage') * 1;
    const apiUrl = window.azure_form.data('search-url');

    let keyword = window.azure_form.find('.search-input').val();

    // ignore if keyword empty
    if (keyword.trim() === '') {
        return;
    }

    // check for redirection
    if (azureRedirectPage()) {
        return;
    }

    // set paggination request
    keyword += `&$skip=${start}&$top=${perpage}`;

    // reset result state, hide pagination, show loader, show container
    azureToggleLoader(true);
    $('#azure-search-result .search-result-item').remove();
    $('.c-pagination-minimal li a').addClass('hide');
    $('#s-azure-search-result').css({ display: 'block' });

    $.ajax({ url: `${apiUrl}&$count=true&search=${keyword}` })
        .done(data => {
            azureToggleLoader(false);
            azureAjaxRender(data);

            // replace this function with more complex pagination
            azureShowHidePagination(start, data['@odata.count'], azureAjaxRequest);
        });
}

// automatically call ajax request if found GET query `ask`
function azureSearchQueryString() {
    const queryString = window.location.search;
    const queries = queryString.split('=');

    // make sure result div exist
    if ($('#azure-search-result').length === 0) {
        return;
    }

    if (queries.length === 2 && queries[0] === '?ask') {
        $('.azure-search-form .search-input').val(queries[1]);
        azureAjaxRequest(0);
    }
}

// handle on press enter
function azureSubmitByEnter() {
    $('.azure-search-form .search-input').keypress(function (e) {
        if (e.which === 13) {
            // mark current form
            azureUpdateFormState($(this));

            // send request
            e.preventDefault();
            azureAjaxRequest(0);
        }
    });
}

// handle submit button
function azureSubmitForm() {
    $('.azure-search-form .search-button').click(function (e) {
        // mark current form
        azureUpdateFormState($(this));

        // send request
        e.preventDefault();
        azureAjaxRequest(0);
    });
}

// Kick off the init on document ready
$(() => {
    initSearchBar();

    if ($('.azure-search-form').length !== 0) {
        window.azure_form = $('.azure-search-form');

        // do other new feature before init here., ie move result container to a better place

        // event on submit
        azureSubmitForm();

        // other new feature function here like search on hit enter
        azureSubmitByEnter();

        // do search if found GET query `ask` (azure search keyword)
        azureSearchQueryString();
    }
});
